export enum QRCodeVariant {
  primary = 'primary',
  secondary = 'secondary',
  success = 'success',
  info = 'info',
  warning = 'warning',
  danger = 'danger',
  low = 'low',
  high = 'high',
  current = 'current'
}

export type CssClassMap = { [className: string]: boolean };
